import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */
import classnames from 'classnames';
/**
 * WordPress dependencies
 */

import { __ } from '@wordpress/i18n';
import { Component, createRef } from '@wordpress/element';
import { withInstanceId, compose } from '@wordpress/compose';
/**
 * Internal dependencies
 */

import BaseControl from '../base-control';
import withFocusOutside from '../higher-order/with-focus-outside';
import { Path, SVG } from '../primitives';
var TEXTCONTROL_MIN = 0;
var TEXTCONTROL_MAX = 100;
export var FocalPointPicker =
/*#__PURE__*/
function (_Component) {
  _inherits(FocalPointPicker, _Component);

  function FocalPointPicker(props) {
    var _this;

    _classCallCheck(this, FocalPointPicker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FocalPointPicker).call(this, props));
    _this.onMouseMove = _this.onMouseMove.bind(_assertThisInitialized(_this));
    _this.state = {
      isDragging: false,
      bounds: {},
      percentages: props.value
    };
    _this.containerRef = createRef();
    _this.imageRef = createRef();
    _this.horizontalPositionChanged = _this.horizontalPositionChanged.bind(_assertThisInitialized(_this));
    _this.verticalPositionChanged = _this.verticalPositionChanged.bind(_assertThisInitialized(_this));
    _this.onLoad = _this.onLoad.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(FocalPointPicker, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.url !== this.props.url) {
        this.setState({
          isDragging: false
        });
      }
    }
  }, {
    key: "calculateBounds",
    value: function calculateBounds() {
      var bounds = {
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        width: 0,
        height: 0
      };

      if (!this.imageRef.current) {
        return bounds;
      }

      var dimensions = {
        width: this.imageRef.current.clientWidth,
        height: this.imageRef.current.clientHeight
      };
      var pickerDimensions = this.pickerDimensions();
      var widthRatio = pickerDimensions.width / dimensions.width;
      var heightRatio = pickerDimensions.height / dimensions.height;

      if (heightRatio >= widthRatio) {
        bounds.width = bounds.right = pickerDimensions.width;
        bounds.height = dimensions.height * widthRatio;
        bounds.top = (pickerDimensions.height - bounds.height) / 2;
        bounds.bottom = bounds.top + bounds.height;
      } else {
        bounds.height = bounds.bottom = pickerDimensions.height;
        bounds.width = dimensions.width * heightRatio;
        bounds.left = (pickerDimensions.width - bounds.width) / 2;
        bounds.right = bounds.left + bounds.width;
      }

      return bounds;
    }
  }, {
    key: "onLoad",
    value: function onLoad() {
      this.setState({
        bounds: this.calculateBounds()
      });
    }
  }, {
    key: "onMouseMove",
    value: function onMouseMove(event) {
      var _this$state = this.state,
          isDragging = _this$state.isDragging,
          bounds = _this$state.bounds;
      var onChange = this.props.onChange;

      if (isDragging) {
        var pickerDimensions = this.pickerDimensions();
        var cursorPosition = {
          left: event.pageX - pickerDimensions.left,
          top: event.pageY - pickerDimensions.top
        };
        var left = Math.max(bounds.left, Math.min(cursorPosition.left, bounds.right));
        var top = Math.max(bounds.top, Math.min(cursorPosition.top, bounds.bottom));
        var percentages = {
          x: (left - bounds.left) / (pickerDimensions.width - bounds.left * 2),
          y: (top - bounds.top) / (pickerDimensions.height - bounds.top * 2)
        };
        this.setState({
          percentages: percentages
        }, function () {
          onChange({
            x: this.state.percentages.x,
            y: this.state.percentages.y
          });
        });
      }
    }
  }, {
    key: "fractionToPercentage",
    value: function fractionToPercentage(fraction) {
      return Math.round(fraction * 100);
    }
  }, {
    key: "horizontalPositionChanged",
    value: function horizontalPositionChanged(event) {
      this.positionChangeFromTextControl('x', event.target.value);
    }
  }, {
    key: "verticalPositionChanged",
    value: function verticalPositionChanged(event) {
      this.positionChangeFromTextControl('y', event.target.value);
    }
  }, {
    key: "positionChangeFromTextControl",
    value: function positionChangeFromTextControl(axis, value) {
      var onChange = this.props.onChange;
      var percentages = this.state.percentages;
      var cleanValue = Math.max(Math.min(parseInt(value), 100), 0);
      percentages[axis] = cleanValue ? cleanValue / 100 : 0;
      this.setState({
        percentages: percentages
      }, function () {
        onChange({
          x: this.state.percentages.x,
          y: this.state.percentages.y
        });
      });
    }
  }, {
    key: "pickerDimensions",
    value: function pickerDimensions() {
      if (this.containerRef.current) {
        return {
          width: this.containerRef.current.clientWidth,
          height: this.containerRef.current.clientHeight,
          top: this.containerRef.current.getBoundingClientRect().top + document.body.scrollTop,
          left: this.containerRef.current.getBoundingClientRect().left
        };
      }

      return {
        width: 0,
        height: 0,
        left: 0,
        top: 0
      };
    }
  }, {
    key: "handleFocusOutside",
    value: function handleFocusOutside() {
      this.setState({
        isDragging: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          instanceId = _this$props.instanceId,
          url = _this$props.url,
          value = _this$props.value,
          label = _this$props.label,
          help = _this$props.help,
          className = _this$props.className;
      var _this$state2 = this.state,
          bounds = _this$state2.bounds,
          isDragging = _this$state2.isDragging,
          percentages = _this$state2.percentages;
      var pickerDimensions = this.pickerDimensions();
      var iconCoordinates = {
        left: value.x * (pickerDimensions.width - bounds.left * 2) + bounds.left,
        top: value.y * (pickerDimensions.height - bounds.top * 2) + bounds.top
      };
      var iconContainerStyle = {
        left: "".concat(iconCoordinates.left, "px"),
        top: "".concat(iconCoordinates.top, "px")
      };
      var iconContainerClasses = classnames('components-focal-point-picker__icon_container', isDragging ? 'is-dragging' : null);
      var id = "inspector-focal-point-picker-control-".concat(instanceId);
      var horizontalPositionId = "inspector-focal-point-picker-control-horizontal-position-".concat(instanceId);
      var verticalPositionId = "inspector-focal-point-picker-control-vertical-position-".concat(instanceId);
      return createElement(BaseControl, {
        label: label,
        id: id,
        help: help,
        className: className
      }, createElement("div", {
        className: "components-focal-point-picker-wrapper"
      }, createElement("div", {
        className: "components-focal-point-picker",
        onMouseDown: function onMouseDown() {
          return _this2.setState({
            isDragging: true
          });
        },
        onDragStart: function onDragStart() {
          return _this2.setState({
            isDragging: true
          });
        },
        onMouseUp: function onMouseUp() {
          return _this2.setState({
            isDragging: false
          });
        },
        onDrop: function onDrop() {
          return _this2.setState({
            isDragging: false
          });
        },
        onMouseMove: this.onMouseMove,
        ref: this.containerRef,
        role: "button",
        tabIndex: "-1"
      }, createElement("img", {
        alt: "Dimensions helper",
        onLoad: this.onLoad,
        ref: this.imageRef,
        src: url,
        draggable: "false"
      }), createElement("div", {
        className: iconContainerClasses,
        style: iconContainerStyle
      }, createElement(SVG, {
        className: "components-focal-point-picker__icon",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 30 30"
      }, createElement(Path, {
        className: "components-focal-point-picker__icon-outline",
        d: "M15 1C7.3 1 1 7.3 1 15s6.3 14 14 14 14-6.3 14-14S22.7 1 15 1zm0 22c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z"
      }), createElement(Path, {
        className: "components-focal-point-picker__icon-fill",
        d: "M15 3C8.4 3 3 8.4 3 15s5.4 12 12 12 12-5.4 12-12S21.6 3 15 3zm0 22C9.5 25 5 20.5 5 15S9.5 5 15 5s10 4.5 10 10-4.5 10-10 10z"
      }))))), createElement("div", {
        className: "components-focal-point-picker_position-display-container"
      }, createElement(BaseControl, {
        label: __('Horizontal Pos.'),
        id: horizontalPositionId
      }, createElement("input", {
        className: "components-text-control__input",
        id: horizontalPositionId,
        max: TEXTCONTROL_MAX,
        min: TEXTCONTROL_MIN,
        onChange: this.horizontalPositionChanged,
        type: "number",
        value: this.fractionToPercentage(percentages.x)
      }), createElement("span", null, "%")), createElement(BaseControl, {
        label: __('Vertical Pos.'),
        id: verticalPositionId
      }, createElement("input", {
        className: "components-text-control__input",
        id: verticalPositionId,
        max: TEXTCONTROL_MAX,
        min: TEXTCONTROL_MIN,
        onChange: this.verticalPositionChanged,
        type: "number",
        value: this.fractionToPercentage(percentages.y)
      }), createElement("span", null, "%"))));
    }
  }]);

  return FocalPointPicker;
}(Component);
FocalPointPicker.defaultProps = {
  url: null,
  value: {
    x: 0.5,
    y: 0.5
  },
  onChange: function onChange() {}
};
export default compose([withInstanceId, withFocusOutside])(FocalPointPicker);
//# sourceMappingURL=index.js.map